export const META_PIXEL_ID = '3894912483991121'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      loaded?: boolean
      version?: string
      push?: unknown
    }
    _fbq?: unknown
  }
}

/**
 * Injects the Meta Pixel base code once and fires the initial PageView.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else {
      fbq.queue?.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)

  const noscript = document.createElement('noscript')
  const pixelImg = document.createElement('img')
  pixelImg.height = 1
  pixelImg.width = 1
  pixelImg.style.display = 'none'
  pixelImg.alt = ''
  pixelImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImg)
  document.body.appendChild(noscript)

  fbq('init', pixelId)
  fbq('track', 'PageView')
}

/** Fires a standard Meta Pixel event, e.g. trackPixelEvent('InitiateCheckout', {...}). */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
